import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-delete-details-dailogue',
  imports: [MaterialModule, TranslateModule, CommonModule],
  templateUrl: './delete-details-dailogue.component.html'
})
export class DeleteDetailsDailogueComponent implements OnInit {
  action: string;
  local_data: any = {};
  displayContactType = '';
  loading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<DeleteDetailsDailogueComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    , public translate: TranslateService) {
    this.local_data = { ...data };
    this.action = this.local_data.action;

    this.translate.use(this.local_data.langCode);
    const dir = this.local_data.langCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
  }

  doAction(): void {
    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }

  ngOnInit(): void {
    this.loading = true;
    setTimeout(() => {
      const contactType = this.data?.contactType;
      if (contactType) {
        this.displayContactType = this.data.langCode === 'en' ? contactType.nameEn : contactType.nameAr;
      }
      this.loading = false;
    }, 1000);
  }
}
